import { alpha } from '@material-ui/core/styles';
import { colors } from '../../constants';
import { SHADOW_LEVEL1, SHADOW_LEVEL2, SHADOW_LEVEL3 } from '../../shadows';
const MuiSlider = {
  rail: {
    height: 4,
    borderRadius: 2
  },
  track: {
    height: 4,
    borderRadius: 2
  },
  mark: {
    height: 4
  },
  thumb: {
    width: 28,
    height: 28,
    marginTop: -12,
    marginLeft: -12,
    backgroundColor: colors.commonColors.white,
    boxShadow: SHADOW_LEVEL1,
    '&:hover, &$focusVisible': {
      boxShadow: SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    '&$active': {
      boxShadow: SHADOW_LEVEL2
    },
    '&$disabled': {
      width: 28,
      height: 28,
      marginTop: -12,
      marginLeft: -12,
      backgroundColor: 'currentColor',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }
  },
  thumbColorPrimary: {
    '&:hover, &$focusVisible': {
      boxShadow: SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    '&$focusVisible': {
      boxShadow: `${SHADOW_LEVEL2}, 0px 0px 0px 8px ${alpha(colors.primary.main, 0.17)}`
    },
    '&$active': {
      boxShadow: SHADOW_LEVEL3
    }
  },
  thumbColorSecondary: {
    '&:hover, &$focusVisible': {
      boxShadow: SHADOW_LEVEL2,
      '@media (hover: none)': {
        boxShadow: 'none'
      }
    },
    '&$focusVisible': {
      boxShadow: `${SHADOW_LEVEL2}, 0px 0px 0px 8px ${alpha(colors.secondary.main, 0.17)}`
    },
    '&$active': {
      boxShadow: SHADOW_LEVEL3
    }
  },
  valueLabel: {
    left: '-7%'
  }
};
export default MuiSlider;